document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu-toggle]');
  if (menu) {
    menu.addEventListener('click', () => {
      const open = document.body.classList.toggle('menu-open');
      menu.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  document.querySelectorAll('[data-grid-cols]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrap = document.querySelector('.collection-grid-wrap');
      if (!wrap) return;
      wrap.dataset.cols = button.dataset.gridCols;
      document.querySelectorAll('[data-grid-cols]').forEach((item) => item.classList.toggle('is-active', item === button));
    });
  });

  document.querySelectorAll('[data-lookbook]').forEach((section) => {
    const slides = [...section.querySelectorAll('[data-lookbook-slide]')];
    let index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
    };
    section.querySelector('[data-look-prev]')?.addEventListener('click', () => show(index - 1));
    section.querySelector('[data-look-next]')?.addEventListener('click', () => show(index + 1));
    if (slides.length) show(0);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const media = [...gallery.querySelectorAll('[data-gallery-media]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.galleryThumb;
        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        media.forEach((item) => {
          const active = item.dataset.galleryMedia === id;
          item.hidden = !active;
          item.classList.toggle('is-active', active);
        });
      });
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantInput = form.querySelector('[name="id"]');
    const script = form.querySelector('[data-variants-json]');
    if (!variantInput || !script) return;
    const variants = JSON.parse(script.textContent);
    const currency = form.dataset.currency || 'USD';
    const priceWrap = document.querySelector('[data-product-price]');
    const currentPrice = priceWrap?.querySelector('[data-current-price]');
    const comparePrice = priceWrap?.querySelector('[data-compare-price]');
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);

    form.querySelectorAll('[data-option-value]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const selected = [...form.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('input:checked')?.value);
        const variant = variants.find((item) => item.options.every((value, i) => value === selected[i]));
        if (!variant) return;
        variantInput.value = variant.id;
        const button = form.querySelector('[type="submit"]');
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (currentPrice) currentPrice.textContent = formatMoney(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap?.classList.toggle('is-sale', Boolean(onSale));
        if (comparePrice) {
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      });
    });
  });

  document.querySelectorAll('product-recommendations[data-url]').forEach((section) => {
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = parsed.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) section.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  });
});
(() => {
  const header = document.querySelector('.site-header');

  if (!header) return;

  const updateStickyHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 20);
  };

  updateStickyHeader();

  window.addEventListener('scroll', updateStickyHeader, {
    passive: true
  });
})();
